import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";
import Home from "@/views/home/index.vue";
import PersonalServices from "@/views/personalServices/index.vue";
import EducationalServices from "@/views/educationalServices/index.vue";
import EmployerServices from "@/views/employerServices/index.vue";
import SocialGroupServices from "@/views/SocialGroupServices/index.vue";
import CooperationProjectSupportServices from "@/views/cooperationProjectSupportServices/index.vue";

import PersonalServicesHome from "@/views/personalServicesHome/index.vue";
import Personal from "@/views/personal/index.vue";
import PersonalInfoList from "@/views/personal/list.vue";
// import AddBaseInfo from "@/views/personal/addBaseInfo.vue";
// import AddEducationInfo from "@/views/personal/AddEducationInfo.vue";
// import AddNonAcademicEducation from "@/views/personal/addNonAcademicEducation.vue";
// import AddWorkExperience from "@/views/personal/addWorkExperience.vue";
// import AddSocialActivityExperience from "@/views/personal/addSocialActivityExperience.vue";
import RealNameAuthentication from "@/views/personal/realNameAuthentication.vue";
import DataSource from "@/views/personal/DataSource.vue";
import Corrigendum from "@/views/personal/Corrigendum.vue";
import CorrigendumRecord from "@/views/personal/CorrigendumRecord.vue";
import CorrigendumDetail from "@/views/personal/CorrigendumDetail.vue";
import CredentialsList from "@/views/personal/report/credentialsList.vue";
import CredentialsDetail from "@/views/personal/report/CredentialsDetail";
import PersonalReportList from "@/views/personal/report/list";
import Create from "@/views/personal/report/create";
import ReportCheckList from "@/views/personal/reportCheck/list";
import AuthReportDetail from "@/views/personal/reportCheck/authReportDetail";
import CheckOthsers from "@/views/personal/checkOthers/index";
import CheckOthsersRecords from "@/views/personal/checkOthers/records";
import ReportPreview from "@/views/reportPreview/index";

import EducationalServicesHome from "@/views/educationalServicesHome/index.vue";
import Educational from "@/views/educational/index.vue";
import ProfessionalList from "@/views/educational/list.vue";
import AddProfessional from "@/views/educational/addProfessional.vue";
import Private from "@/views/private/index";
import Agreement from "@/views/agreement/index";
import Intro from "@/views/intro/index";
import News from "@/views/news/index";
import NewsList from "@/views/news/list";
import NewsDetail from "@/views/news/detail";
// v2.0 22.10.12
import QAList from "@/views/QA/list";
import Version from "@/views/version/index";

// 2023.6.29
import EducationalAdmin from "@/views/educational/admin.vue";
import EducationalStaffList from "@/views/educational/staffList.vue";
import StaffDetail from "@/views/educational/staffDetail.vue";

import EmployerAdmin from "@/views/employer/admin.vue";
import EmployerAdminList from "@/views/employer/adminList.vue";
import AdminDetail from "@/views/employer/adminDetail.vue";

// import Home from "./views/views/home/index";

import EmployerServicesHome from "@/views/employerServicesHome/index.vue";

Vue.use(Router);

//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 固定路由 非权限路由
export const constantRoutes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "首页"
    }
  },
  {
    path: "/private",
    name: "Private",
    component: Private,
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: Agreement,
    meta: {
      title: "用户协议"
    }
  },
  {
    path: "/intro",
    name: "Intro",
    meta: {
      title: "平台介绍"
    },
    component: Intro
  },
  {
    path: "/news",
    name: "News",
    meta: {
      title: "新闻中心"
    },
    component: News,
    // redirect:"/news/list?type=0",
    children: [
      {
        path: "list",
        name: "NewsList",
        component: NewsList,
        meta: {
          title: "新闻中心-新闻列表"
        }
      },
      {
        path: "detail",
        name: "NewsDetail",
        component: NewsDetail,
        meta: {
          title: "新闻中心-新闻详情"
        }
      }
    ]
  },
  {
    path: "/qa",
    name: "QA",
    meta: {
      title: "Q&A"
    },
    component: QAList,
    // redirect:"/news/list?type=0",
    children: [
      {
        path: "list",
        name: "QAList",
        component: QAList,
        meta: {
          title: "Q&A"
        }
      }
    ]
  },
  {
    path: "/version",
    name: "Version",
    meta: {
      title: "版本更新记录"
    },
    component: Version,
    // redirect:"/news/list?type=0",
    children: [
      {
        path: "list",
        name: "Version",
        component: Version,
        meta: {
          title: "Q&A"
        }
      }
    ]
  },
  {
    path: "/personalServices",
    name: "PersonalServices",
    meta: {
      title: "个人服务"
    },
    component: PersonalServices
  },
  {
    path: "/educationalServices",
    name: "EducationalServices",
    meta: {
      title: "教育机构服务"
    },
    component: EducationalServices
  },
  {
    path: "/employerServices",
    name: "EmployerServices",
    meta: {
      title: "用人单位服务"
    },
    component: EmployerServices
  },
  {
    path: "/socialGroupServices",
    name: "SocialGroupServices",
    meta: {
      title: "社会团体服务"
    },
    component: SocialGroupServices
  },
  {
    path: "/cooperationProjectSupportServices",
    name: "CooperationProjectSupportServices",
    meta: {
      title: "合作项目支撑服务"
    },
    component: CooperationProjectSupportServices
  }
];
// 异步路由 根据权限筛选
export const asyncRoutes = [
  // 个人服务
  {
    path: "/personalServicesHome",
    name: "PersonalServicesHome",
    component: PersonalServicesHome,
    meta: {
      title: "个人服务-首页",
      roles: ["CONSUMER"]
    }
  },
  {
    path: "/reportPreview",
    name: "ReportPreview",
    component: ReportPreview,
    meta: {
      title: "证书报告",
      roles: ["CONSUMER"]
    }
  },
  {
    path: "/personal",
    name: "Personal",
    redirect: "/personal/index",
    component: Personal,
    meta: {
      roles: ["CONSUMER"]
    },
    children: [
      {
        path: "index",
        name: "Personal",
        component: PersonalInfoList,
        meta: {
          title: "个人服务-数据档案"
        }
      },
      {
        path: "/personal/realNameAuthentication",
        name: "RealNameAuthentication",
        component: RealNameAuthentication,
        meta: {
          title: "个人服务-实名认证"
        }
      },
      {
        path: "/personal/dataSource",
        name: "DataSource",
        component: DataSource,
        meta: {
          title: "个人服务-数据来源"
        }
      },
      {
        path: "/personal/corrigendum",
        name: "Corrigendum",
        component: Corrigendum,
        meta: {
          title: "个人服务-勘误"
        }
      },
      {
        path: "/personal/corrigendumRecord",
        name: "CorrigendumRecord",
        component: CorrigendumRecord,
        meta: {
          title: "个人服务-勘误记录"
        }
      },
      {
        path: "/personal/corrigendumDetail",
        name: "CorrigendumDetail",
        component: CorrigendumDetail,
        meta: {
          title: "个人服务-勘误详情"
        }
      },
      {
        path: "/personal/report/list",
        name: "PersonalReportList",
        component: PersonalReportList,
        meta: {
          title: "个人服务-个人信息报告"
        }
      },
      {
        path: "/personal/report/credentialsList",
        name: "CredentialsList",
        component: CredentialsList,
        meta: {
          title: "个人服务-证书列表"
        }
      },
      {
        path: "/personal/report/credentialsDetail",
        name: "CredentialsDetail",
        component: CredentialsDetail,
        meta: {
          title: "个人服务-访客记录"
        }
      },
      {
        path: "/personal/report/create",
        name: "Create",
        component: Create,
        meta: {
          title: "个人服务-创建证书"
        }
      },
      {
        path: "/personal/reportCheck/list",
        name: "ReportCheckList",
        component: ReportCheckList,
        meta: {
          title: "个人服务-查验申请"
        }
      },
      {
        path: "/personal/reportCheck/authReportDetail",
        name: "AuthReportDetail",
        component: AuthReportDetail,
        meta: {
          title: "个人服务-设置默认操作"
        }
      },
      {
        path: "/personal/checkOthers/index",
        name: "CheckOthsers",
        component: CheckOthsers,
        meta: {
          title: "个人服务-查验他人"
        }
      },
      {
        path: "/personal/checkOthers/records",
        name: "CheckOthsersRecords",
        component: CheckOthsersRecords,
        meta: {
          title: "个人服务-查验记录"
        }
      }
    ]
  },
  // 教育机构服务
  {
    path: "/educationalServicesHome",
    name: "EducationalServicesHome",
    component: EducationalServicesHome,
    meta: {
      roles: ["ACADEMIC_EDUCATION", "NON_ACADEMIC_EDUCATION"]
    }
  },
  {
    path: "/educational",
    name: "Educational",
    redirect: "/educational/index",
    component: Educational,
    meta: {
      roles: ["ACADEMIC_EDUCATION", "NON_ACADEMIC_EDUCATION"]
    },
    children: [
      {
        path: "index",
        name: "ProfessionalList",
        meta: {
          title: "教育专业管理"
        },
        component: ProfessionalList
      },
      {
        path: "addProfessional",
        name: "AddProfessional",
        meta: {
          title: "添加专业",
          hidden: true
        },
        component: AddProfessional
      },
      {
        path: "classList",
        name: "ClassList",
        meta: {
          title: "班期与学生管理"
        },
        component: () => import("@/views/educational/classList.vue")
      },
      {
        path: "addClass",
        name: "AddClass",
        meta: {
          title: "添加班期",
          hidden: true
        },
        component: () => import("@/views/educational/addClass.vue")
      },
      {
        path: "studentList",
        name: "StudentList",
        meta: {
          // title: '添加学生信息',
          hidden: true
        },
        component: () => import("@/views/educational/studentList.vue")
      },
      {
        path: "addStudent",
        name: "AddStudent",
        meta: {
          title: "添加学生信息",
          hidden: true
        },
        component: () => import("@/views/educational/addStudent.vue")
      },
      {
        path: "studentDetail",
        name: "StudentDetail",
        meta: {
          title: "学生信息",
          hidden: true
        },
        component: () => import("@/views/educational/studentDetail.vue")
      },
      {
        path: "corrigendaList",
        name: "CorrigendaList",
        meta: {
          title: "勘误申请处理"
        },
        component: () => import("@/views/educational/corrigendaList.vue")
      },
      {
        path: "corrigendaDetail",
        name: "CorrigendaDetail",
        meta: {
          title: "勘误详情",
          hidden: true
        },
        component: () => import("@/views/educational/corrigendaDetail.vue")
      },
      {
        path: "addProduct",
        name: "AddProduct",
        meta: {
          title: "添加产品",
          hidden: true
        },
        component: () => import("@/views/educational/addProduct.vue")
      },
      {
        path: "incidentList",
        name: "IncidentList",
        meta: {
          title: "活动/事件管理"
        },
        component: () => import("@/views/educational/incidentList.vue")
      },
      {
        path: "addIncident",
        name: "AddIncident",
        meta: {
          title: "添加事件",
          hidden: true
        },
        component: () => import("@/views/educational/addIncident.vue")
      },
      {
        path: "incidentDetail",
        name: "IncidentDetail",
        meta: {
          title: "事件详情",
          hidden: true
        },
        component: () => import("@/views/educational/incidentDetail.vue")
      },
      {
        path: "incidentOneDetail",
        name: "IncidentOneDetail",
        meta: {
          title: "事件详情",
          hidden: true
        },
        component: () => import("@/views/educational/incidentOneDetail.vue")
      },
      {
        path: "studentAllList",
        name: "StudentAllList",
        meta: {
          title: "所有学生列表"
        },
        component: () => import("@/views/educational/studentAllList.vue")
      }
    ]
  },
  // 机构主账号admin
  {
    path: "/educationalAdmin",
    name: "EducationalAdmin",
    redirect: "/educationalAdmin/staff",
    component: EducationalAdmin,
    meta: {
      roles: ["ACADEMIC_EDUCATION", "NON_ACADEMIC_EDUCATION"]
    },
    children: [
      {
        path: "staff",
        name: "StaffList",
        meta: {
          title: "帐号管理"
        },
        component: EducationalStaffList
      },
      {
        path: "addStaff",
        name: "AddStaff",
        meta: {
          title: "添加帐号",
          hidden: true
        },
        component: StaffDetail
      },
      {
        path: "updateStaff",
        name: "UpdateStaff",
        meta: {
          title: "修改帐号",
          hidden: true
        },
        component: StaffDetail
      },
      {
        path: "staffDetail",
        name: "StaffDetail",
        meta: {
          title: "帐号详情",
          hidden: true
        },
        component: StaffDetail
      },
      {
        path: "feeRefundList",
        name: "FeeRefundList",
        meta: {
          title: "费用返还记录"
        },
        component: () => import("@/views/educational/feeRefundList.vue")
      }
    ]
  },
  {
    path: "/employerAdmin",
    name: "EmployerAdmin",
    redirect: "/employerAdmin/admin",
    component: EmployerAdmin,
    meta: {
      roles: ["EMPLOYER"]
      // roles: ['ACADEMIC_EDUCATION', 'NON_ACADEMIC_EDUCATION'],
    },
    children: [
      {
        path: "admin",
        name: "AdminList",
        meta: {
          title: "帐号管理"
        },
        component: EmployerAdminList
      },
      {
        path: "addAdmin",
        name: "AddAdmin",
        meta: {
          title: "添加帐号",
          hidden: true
        },
        component: AdminDetail
      },
      {
        path: "updateAdmin",
        name: "UpdateAdmin",
        meta: {
          title: "修改帐号",
          hidden: true
        },
        component: AdminDetail
      },
      {
        path: "adminDetail",
        name: "AdminDetail",
        meta: {
          title: "帐号详情",
          hidden: true
        },
        component: AdminDetail
      },
      {
        path: "feeRefundList",
        name: "FeeRefundList",
        meta: {
          title: "费用返还记录"
        },
        component: () => import("@/views/employer/feeRefundList.vue")
      }
    ]
  },
  // 用人单位服务
  {
    path: "/employerServicesHome",
    name: "EmployerServicesHome",
    component: EmployerServicesHome,
    meta: {
      roles: ["EMPLOYER"]
    }
  },
  {
    path: "/employer",
    name: "Employer",
    redirect: "/employer/index",
    component: () => import("@/views/employer/index.vue"),
    meta: {
      roles: ["EMPLOYER"]
    },
    children: [
      {
        path: "index",
        name: "employerList",
        meta: {
          title: "职员信息管理"
        },
        component: () => import("@/views/employer/list.vue")
      },
      {
        path: "addStaff",
        name: "employerAddStaff",
        meta: {
          title: "添加新职员",
          hidden: true
        },
        component: () => import("@/views/employer/addStaff.vue")
      },
      {
        path: "staffDetail",
        name: "employerStaffDetail",
        meta: {
          title: "职员信息",
          hidden: true
        },
        component: () => import("@/views/employer/staffDetail.vue")
      },
      // 勘误
      {
        path: "corrigendaList",
        name: "CorrigendaList",
        meta: {
          title: "勘误申请"
        },
        component: () => import("@/views/educational/corrigendaList.vue")
      },
      {
        path: "corrigendaDetail",
        name: "MCorrigendaDetail",
        meta: {
          title: "勘误详情",
          hidden: true
        },
        component: () => import("@/views/educational/corrigendaDetail.vue")
      },
      {
        path: "incidentList",
        name: "IncidentList",
        meta: {
          title: "事件管理"
        },
        component: () => import("@/views/educational/incidentList.vue")
      },
      {
        path: "addIncident",
        name: "AddIncident",
        meta: {
          title: "添加事件",
          hidden: true
        },
        component: () => import("@/views/educational/addIncident.vue")
      },
      {
        path: "postDetail",
        name: "PostDetail",
        meta: {
          title: "岗位记录详情",
          hidden: true
        },
        component: () => import("@/views/employer/postDetail.vue")
      },
      {
        path: "incidentDetail",
        name: "IncidentDetail",
        meta: {
          title: "事件详情",
          hidden: true
        },
        component: () => import("@/views/educational/incidentDetail.vue")
      },
      {
        path: "incidentOneDetail",
        name: "IncidentOneDetail",
        meta: {
          title: "事件详情",
          hidden: true
        },
        component: () => import("@/views/educational/incidentOneDetail.vue")
      }
    ]
  }
];

export default new Router({
  mode: "history", // require service support
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...constantRoutes

    // {
    //   path: "/personalServicesHome",
    //   name: "PersonalServicesHome",
    //   component: PersonalServicesHome,
    //   meta: {
    //     title: "个人服务-首页"
    //   }
    // },
    // {
    //   path: "/reportPreview",
    //   name: "ReportPreview",
    //   component: ReportPreview,
    //   meta: {
    //     title: "证书报告"
    //   }
    // },
    // {
    //   path: "/personal",
    //   name: "Personal",
    //   redirect: "/personal/index",
    //   component: Personal,
    //   children: [
    //     {
    //       path: "index",
    //       name: "Personal",
    //       component: PersonalInfoList,
    //       meta: {
    //         title: "个人服务-数据档案"
    //       }
    //     },
    //     // {
    //     //   path: "/personal/addBaseInfo",
    //     //   name: "AddBaseInfo",
    //     //   component: AddBaseInfo
    //     // },
    //     // {
    //     //   path: "/personal/addEducationInfo",
    //     //   name: "AddEducationInfo",
    //     //   component: AddEducationInfo
    //     // },
    //     // {
    //     //   path: "/personal/addWorkExperience",
    //     //   name: "AddWorkExperience",
    //     //   component: AddWorkExperience
    //     // },
    //     // {
    //     //   path: "/personal/addSocialActivityExperience",
    //     //   name: "AddSocialActivityExperience",
    //     //   component: AddSocialActivityExperience
    //     // },
    //     // {
    //     //   path: "/personal/addNonAcademicEducation",
    //     //   name: "AddNonAcademicEducation",
    //     //   component: AddNonAcademicEducation
    //     // },
    //     {
    //       path: "/personal/realNameAuthentication",
    //       name: "RealNameAuthentication",
    //       component: RealNameAuthentication,
    //       meta: {
    //         title: "个人服务-实名认证"
    //       }
    //     },
    //     {
    //       path: "/personal/dataSource",
    //       name: "DataSource",
    //       component: DataSource,
    //       meta: {
    //         title: "个人服务-数据来源"
    //       }
    //     },
    //     {
    //       path: "/personal/corrigendum",
    //       name: "Corrigendum",
    //       component: Corrigendum,
    //       meta: {
    //         title: "个人服务-勘误"
    //       }
    //     },
    //     {
    //       path: "/personal/corrigendumRecord",
    //       name: "CorrigendumRecord",
    //       component: CorrigendumRecord,
    //       meta: {
    //         title: "个人服务-勘误记录"
    //       }
    //     },
    //     {
    //       path: "/personal/corrigendumDetail",
    //       name: "CorrigendumDetail",
    //       component: CorrigendumDetail,
    //       meta: {
    //         title: "个人服务-勘误详情"
    //       }
    //     },
    //     {
    //       path: "/personal/report/list",
    //       name: "PersonalReportList",
    //       component: PersonalReportList,
    //       meta: {
    //         title: "个人服务-个人信息报告"
    //       }
    //     },
    //     {
    //       path: "/personal/report/credentialsList",
    //       name: "CredentialsList",
    //       component: CredentialsList,
    //       meta: {
    //         title: "个人服务-证书列表"
    //       }
    //     },
    //     {
    //       path: "/personal/report/credentialsDetail",
    //       name: "CredentialsDetail",
    //       component: CredentialsDetail,
    //       meta: {
    //         title: "个人服务-访客记录"
    //       }
    //     },
    //     {
    //       path: "/personal/report/create",
    //       name: "Create",
    //       component: Create,
    //       meta: {
    //         title: "个人服务-创建证书"
    //       }
    //     },
    //     {
    //       path: "/personal/reportCheck/list",
    //       name: "ReportCheckList",
    //       component: ReportCheckList,
    //       meta: {
    //         title: "个人服务-查验申请"
    //       }
    //     },
    //     {
    //       path: "/personal/reportCheck/authReportDetail",
    //       name: "AuthReportDetail",
    //       component: AuthReportDetail,
    //       meta: {
    //         title: "个人服务-设置默认操作"
    //       }
    //     },
    //     {
    //       path: "/personal/checkOthers/index",
    //       name: "CheckOthsers",
    //       component: CheckOthsers,
    //       meta: {
    //         title: "个人服务-查验他人"
    //       }
    //     },
    //     {
    //       path: "/personal/checkOthers/records",
    //       name: "CheckOthsersRecords",
    //       component: CheckOthsersRecords,
    //       meta: {
    //         title: "个人服务-查验记录"
    //       }
    //     }
    //   ]
    // },

    // {
    //   path: "/educationalServicesHome",
    //   name: "EducationalServicesHome",
    //   component: EducationalServicesHome
    // },
    // {
    //   path: "/educational",
    //   name: "Educational",
    //   redirect: "/educational/index",
    //   component: Educational,
    //   children: [
    //     {
    //       path: "index",
    //       name: "ProfessionalList",
    //       meta: {
    //         title: "教育专业管理"
    //       },
    //       component: ProfessionalList
    //     },
    //     {
    //       path: "addProfessional",
    //       name: "AddProfessional",
    //       meta: {
    //         title: "添加专业",
    //         hidden: true
    //       },
    //       component: AddProfessional
    //     },
    //     {
    //       path: "classList",
    //       name: "ClassList",
    //       meta: {
    //         title: "班期与学生管理"
    //       },
    //       component: () => import("@/views/educational/classList.vue")
    //     },
    //     {
    //       path: "addClass",
    //       name: "AddClass",
    //       meta: {
    //         title: "添加班期",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/addClass.vue")
    //     },
    //     {
    //       path: "studentList",
    //       name: "StudentList",
    //       meta: {
    //         // title: '添加学生信息',
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/studentList.vue")
    //     },
    //     {
    //       path: "addStudent",
    //       name: "AddStudent",
    //       meta: {
    //         title: "添加学生信息",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/addStudent.vue")
    //     },
    //     {
    //       path: "studentDetail",
    //       name: "StudentDetail",
    //       meta: {
    //         title: "学生信息",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/studentDetail.vue")
    //     },
    //     {
    //       path: "corrigendaList",
    //       name: "CorrigendaList",
    //       meta: {
    //         title: "勘误申请处理"
    //       },
    //       component: () => import("@/views/educational/corrigendaList.vue")
    //     },
    //     {
    //       path: "corrigendaDetail",
    //       name: "CorrigendaDetail",
    //       meta: {
    //         title: "勘误详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/corrigendaDetail.vue")
    //     },
    //     {
    //       path: "addProduct",
    //       name: "AddProduct",
    //       meta: {
    //         title: "添加产品",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/addProduct.vue")
    //     },
    //     {
    //       path: "incidentList",
    //       name: "IncidentList",
    //       meta: {
    //         title: "活动/事件管理"
    //       },
    //       component: () => import("@/views/educational/incidentList.vue")
    //     },
    //     {
    //       path: "addIncident",
    //       name: "AddIncident",
    //       meta: {
    //         title: "添加事件",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/addIncident.vue")
    //     },
    //     {
    //       path: "incidentDetail",
    //       name: "IncidentDetail",
    //       meta: {
    //         title: "事件详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/incidentDetail.vue")
    //     },
    //     {
    //       path: "incidentOneDetail",
    //       name: "IncidentOneDetail",
    //       meta: {
    //         title: "事件详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/incidentOneDetail.vue")
    //     },
    //     {
    //       path: "studentAllList",
    //       name: "StudentAllList",
    //       meta: {
    //         title: "所有学生列表"
    //       },
    //       component: () => import("@/views/educational/studentAllList.vue")
    //     }
    //   ]
    // },
    // {
    //   path: "/employerServicesHome",
    //   name: "EmployerServicesHome",
    //   component: EmployerServicesHome
    // },
    // {
    //   path: "/employer",
    //   name: "Employer",
    //   redirect: "/employer/index",
    //   component: () => import("@/views/employer/index.vue"),
    //   children: [
    //     {
    //       path: "index",
    //       name: "employerList",
    //       meta: {
    //         title: "职员信息管理"
    //       },
    //       component: () => import("@/views/employer/list.vue")
    //     },
    //     {
    //       path: "addStaff",
    //       name: "employerAddStaff",
    //       meta: {
    //         title: "添加新职员",
    //         hidden: true
    //       },
    //       component: () => import("@/views/employer/addStaff.vue")
    //     },
    //     {
    //       path: "staffDetail",
    //       name: "employerStaffDetail",
    //       meta: {
    //         title: "职员信息",
    //         hidden: true
    //       },
    //       component: () => import("@/views/employer/staffDetail.vue")
    //     },
    //     // 勘误
    //     {
    //       path: "corrigendaList",
    //       name: "CorrigendaList",
    //       meta: {
    //         title: "勘误申请"
    //       },
    //       component: () => import("@/views/educational/corrigendaList.vue")
    //     },
    //     {
    //       path: "corrigendaDetail",
    //       name: "MCorrigendaDetail",
    //       meta: {
    //         title: "勘误详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/corrigendaDetail.vue")
    //     },
    //     {
    //       path: "incidentList",
    //       name: "IncidentList",
    //       meta: {
    //         title: "事件管理"
    //       },
    //       component: () => import("@/views/educational/incidentList.vue")
    //     },
    //     {
    //       path: "addIncident",
    //       name: "AddIncident",
    //       meta: {
    //         title: "添加事件",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/addIncident.vue")
    //     },
    //     {
    //       path: "postDetail",
    //       name: "PostDetail",
    //       meta: {
    //         title: "岗位记录详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/employer/postDetail.vue")
    //     },
    //     {
    //       path: "incidentDetail",
    //       name: "IncidentDetail",
    //       meta: {
    //         title: "事件详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/incidentDetail.vue")
    //     },
    //     {
    //       path: "incidentOneDetail",
    //       name: "IncidentOneDetail",
    //       meta: {
    //         title: "事件详情",
    //         hidden: true
    //       },
    //       component: () => import("@/views/educational/incidentOneDetail.vue")
    //     }
    //   ]
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo(0, 0);
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js